import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'src/store/auth';

import type { LoginRequest } from 'src/services/interfaces/auth';

export const useRegister = () => {
  const { register: registerAction, clear, error, isLoading } = useAuthStore();
  const navigate = useNavigate();

  const handleRegister = async (credentials: LoginRequest) => {
    await registerAction(credentials);

    // If registration was successful, the token will be stored in localStorage
    if (localStorage.getItem('token')) {
      navigate('/', { replace: true });
    }
  };

  return { clear, register: handleRegister, error, isLoading };
};
